// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AutoOpenController from "./auto_open_controller"
application.register("auto-open", AutoOpenController)

import SubscriptionController from "./subscription_controller"
application.register("subscription", SubscriptionController)

import ConfettiController from "./confetti_controller"
application.register('confetti', ConfettiController)

// import AlertController from "./alert_controller"
// application.register('alert', AlertController)

import ClipboardController from "./clipboard_controller"
application.register('clipboard', ClipboardController)

import DisappearController from "./disappear_controller"
application.register('disappear', DisappearController)

import NotificationsController from "./notifications_controller"
application.register("notifications", NotificationsController)

import ChartsController from "./charts_controller"
application.register("charts", ChartsController)

import HeartController from "./heart_controller"
application.register("heart", HeartController)
